// extracted by mini-css-extract-plugin
export var backupIcon = "_o1-1";
export var image = "_o1-0";